export const TRANSLATIONS_CACHE_MAX_AGE = 15;
export const TRANSLATIONS_ENDPOINT = '/system/ajax/Localization/Translate';
export const TRANSLATIONS_QUERY_PARAMETER_NAME = 'keys';
//# sourceMappingURL=translations.js.map